export default "__VITE_ASSET__CReg8sGJ__"